import { loadScripts } from '@analytics/util/scriptLoader';
import { Analytics } from '@analytics/types/Analytics';
import Awindow from '@analytics/types/Awindow';
import logger from '@analytics/util/logger';
import { SmartoctoOptions, Params } from './types/Smartocto';

interface SWindow extends Awindow {
  _ain: any;
  tentacles: any;
}

declare let window: SWindow;

export default class Smartocto implements Analytics {
  private stfUrl =
    'https://d7d3cf2e81d293050033-3dfc0615b0fd7b49143049256703bfce.ssl.cf1.rackcdn.com/stf.js';
  private tentacleUrl = 'https://tentacles.smartocto.com/ten/tentacle.js';

  private options!: SmartoctoOptions;

  /**
   * Load script and initialize tracker
   */
  public async init(options: SmartoctoOptions) {
    this.options = options;

    if (!this.options?.apiToken) {
      logger.error('Smartocto apiToken not provided');
      return;
    }

    if (!this.options?.domainId) {
      logger.error('Smartocto domain_id not provided');
      return;
    }

    // Set apiToken before init
    window.tentacles = {};
    window.tentacles.apiToken = this.options.apiToken;
    window._ain = {
      id: this.options.domainId,
      trackauto: false,
    };

    await this.loadScript();
  }

  public pageView(params?: Params) {
    window._ain = { ...window._ain, ...params };
    window._ain.track();
  }

  private async loadScript() {
    await loadScripts(this.stfUrl);
    await loadScripts(this.tentacleUrl);
  }
}
